module.exports = __webpack_public_path__ + "img/icon-6.4e0dc5e6.png";